export default __webpack_public_path__ + "static/media/hallway-mid-reverse.268923ba.mp4";